import { version } from '@/../package.json'
import apiRequest from '@/network/httpClient'
import { Defaults, Options } from '@/orm/models/Setting'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import { ts } from '@/plugins/i18nFormat'
import { AES } from 'crypto-es'
import { useRepo } from 'pinia-orm'
import { Notify, QSpinnerGears } from 'quasar'

// Authenticate to sailing.cz
export async function authenticate(username: string, password: string) {
    const encryptionPassphrase = 'p9wVp1vv1zMn1y86aDhiL0a3EYWDUrI6'

    const encryptedPassword = AES.encrypt(password, encryptionPassphrase).toString()

    const settingsRepo = useRepo(SettingsRepo)

    if (settingsRepo.getOption(Options.AuthToken, Defaults.AuthToken).length > 0)
        await apiLogOut()

    return apiRequest().post('/auth/login', {
        username: username,
        password: encryptedPassword,
        software: 'scoring-system/' + version,
    }).then(response => {
        if (response.status === 200) {
            if (!response.data.roles.includes('referee'))
                return 3

            settingsRepo.setOption(Options.AuthToken, response.data.token)
            settingsRepo.setOption(Options.AuthFullName, response.data.fullName)
            settingsRepo.setOption(Options.AuthRegId, response.data.regId)

            return 0
        } else {
            return 2
        }
    }).catch(function(error) {
        return error.response.status === 401 ? 1 : 2
    })
}

export async function apiLogOut() {
    const settingsRepo = useRepo(SettingsRepo)

    settingsRepo.setOption(Options.SailingDataLoadingState, 'false')

    apiRequest(settingsRepo.getOption(Options.AuthToken, Defaults.AuthToken))
        .post('/auth/logout')
        .then(() => {
        })
        .catch(() => {
        })
        .finally(function() {
            useRepo(SettingsRepo).setOption(Options.AuthToken, Defaults.AuthToken)
            useRepo(SettingsRepo).setOption(Options.AuthFullName, Defaults.AuthFullName)
            useRepo(SettingsRepo).setOption(Options.AuthRegId, Defaults.AuthRegId)
        })
}

export async function checkAuth() {
    const settingsRepo = useRepo(SettingsRepo)

    const authToken = settingsRepo.getOption(Options.AuthToken, Defaults.AuthToken)

    if (authToken === '')
        return 'unauth'

    await apiRequest(authToken)
        .get('/auth/check')
        .catch((error) => {
            if (error.response?.status === 401) {
                Notify.create({
                    type: 'secondary',
                    spinner: QSpinnerGears,
                    message: ts('notAuthNow'),
                    timeout: 4000,
                })

                settingsRepo.setOption(Options.AuthToken, Defaults.AuthToken)
                settingsRepo.setOption(Options.AuthFullName, Defaults.AuthFullName)
                settingsRepo.setOption(Options.AuthRegId, Defaults.AuthRegId)
            }
        })

    if (settingsRepo.getOption(Options.AuthToken, Defaults.AuthToken) === '')
        return 'expired'

    return 'auth'
}

export function showError(error: number, firstTime: boolean = false) {
    const errors = [
        'authenticationExpired',
        'notAuthenticated',
        'unknownErrorDuringAuthentication',
        'noRefereeRole',
    ]

    return (error === 0 && firstTime) ? '' : ts(errors[error])
}
